<style scoped>

.dt-root {

  --dt-primary: #2563eb;

  --dt-border: #e2e8f0;

  --dt-muted: #64748b;

  --dt-bg: #f8fafc;

  --dt-text: #0f172a;

}

[role=button] { cursor: pointer; }

.dt-toolbar {

  background: #fff;

  border: 1px solid var(--dt-border);

  border-radius: 16px;

  padding: 18px 20px;

  margin-bottom: 16px;

  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);

}

.dt-search { position: relative; width: 100%; }

.dt-search__icon {

  position: absolute; left: 14px; top: 50%; transform: translateY(-50%);

  color: var(--dt-muted); font-size: 14px;

}

.dt-search__input {

  width: 100%; height: 42px; padding: 0 14px 0 40px;

  border: 1px solid var(--dt-border); border-radius: 12px;

  background: var(--dt-bg); color: var(--dt-text); font-size: 0.875rem;

  transition: border-color .15s ease, box-shadow .15s ease, background .15s ease;

}

.dt-search__input:focus {

  outline: none; border-color: #93c5fd; background: #fff;

  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);

}

.dt-actions { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; }
.dt-actions >>> .btn {
  display: inline-flex; align-items: center; gap: 8px; height: 42px; padding: 0 16px;
  border-radius: 12px; font-size: 0.8125rem; font-weight: 600; transition: all .15s ease;
}
.dt-actions >>> .btn:hover { transform: translateY(-1px); box-shadow: 0 6px 16px rgba(15, 23, 42, 0.06); }

.dt-btn {

  display: inline-flex; align-items: center; gap: 8px; height: 42px; padding: 0 16px;

  border-radius: 12px; font-size: 0.8125rem; font-weight: 600;

  border: 1px solid var(--dt-border); background: #fff; color: var(--dt-text);

  transition: all .15s ease;

}

.dt-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 16px rgba(15, 23, 42, 0.06); }

.dt-btn--excel { color: #059669; border-color: #bbf7d0; background: #f0fdf4; }

.dt-btn--filter { color: var(--dt-primary); border-color: #bfdbfe; background: #eff6ff; }

.dt-btn--filter.is-active { background: var(--dt-primary); color: #fff; border-color: var(--dt-primary); }

.dt-filters { margin-top: 14px; padding-top: 14px; border-top: 1px dashed var(--dt-border); }

.dt-meta {

  display: flex; flex-wrap: wrap; justify-content: space-between; align-items: center;

  gap: 12px; padding: 10px 4px 14px;

}

.dt-meta__count { display: inline-flex; align-items: center; gap: 8px; font-size: 0.875rem; color: var(--dt-muted); }

.dt-meta__count strong { color: var(--dt-text); font-size: 1rem; }

.dt-badge {

  display: inline-flex; align-items: center; padding: 4px 10px; border-radius: 999px;

  background: rgba(37, 99, 235, 0.08); color: var(--dt-primary);

  font-size: 11px; font-weight: 700; letter-spacing: .03em; text-transform: uppercase;

}

.dt-pagination { display: flex; gap: 6px; margin: 0; padding: 0; list-style: none; }

.dt-page-link {

  display: inline-flex; align-items: center; gap: 6px; padding: 8px 14px; border-radius: 10px;

  border: 1px solid var(--dt-border); background: #fff; color: var(--dt-text);

  font-size: 0.8125rem; font-weight: 600; text-decoration: none; transition: all .15s ease;

}

.dt-page-link:hover { border-color: #bfdbfe; color: var(--dt-primary); }

.dt-page-link.is-current { background: var(--dt-primary); border-color: var(--dt-primary); color: #fff; pointer-events: none; }

.dt-card {

  background: #fff; border: 1px solid var(--dt-border); border-radius: 16px;

  overflow: hidden; box-shadow: 0 10px 30px rgba(15, 23, 42, 0.04);

}

.dt-loading, .dt-loading-more {

  display: flex; align-items: center; justify-content: center; gap: 10px;

  padding: 48px 20px; color: var(--dt-muted); font-size: 0.875rem;

}

.dt-loading-more { padding: 20px; border-top: 1px solid var(--dt-border); background: var(--dt-bg); }

.dt-empty { text-align: center; padding: 56px 20px; color: var(--dt-muted); }

.dt-empty__icon { font-size: 2rem; color: #cbd5e1; margin-bottom: 10px; }

.dt-table-wrap { min-height: 300px; }

.dt-table { margin: 0; width: 100%; border-collapse: separate; border-spacing: 0; }

.dt-table thead th {

  position: sticky; top: 0; z-index: 2; background: var(--dt-bg); color: var(--dt-muted);

  font-size: 11px; font-weight: 700; letter-spacing: .05em; text-transform: uppercase;

  border-bottom: 1px solid var(--dt-border); padding: 14px 12px; white-space: nowrap;

}

.dt-table thead th.dt-sortable { cursor: pointer; user-select: none; transition: color .15s ease, background .15s ease; }

.dt-table thead th.dt-sortable:hover { color: var(--dt-primary); background: #f1f5f9; }

.dt-table thead th.dt-sort-active { color: var(--dt-primary); background: #eff6ff; }

.dt-table tbody td, .dt-table tbody th {

  padding: 12px; font-size: 0.8125rem; color: #334155;

  border-bottom: 1px solid #f1f5f9; vertical-align: middle;

}

.dt-table tbody tr:last-child td, .dt-table tbody tr:last-child th { border-bottom: none; }

.dt-row { cursor: pointer; transition: background .12s ease; }

.dt-row:hover { background: #f8fafc; }

.dt-row:focus { outline: none; background: #eff6ff; }

.dt-index { width: 48px; color: var(--dt-muted) !important; font-weight: 600; font-size: 12px !important; background: #fcfdfe; }

._cell { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 0; }

.dt-sort-icon { font-size: 14px; opacity: .55; }

.dt-sort-active .dt-sort-icon { opacity: 1; color: var(--dt-primary); }

.dt-table thead th.dt-col-action,
.dt-table tbody td.dt-col-action {
  width: 52px;
  min-width: 52px;
  max-width: 52px;
  padding-left: 8px;
  padding-right: 8px;
  white-space: nowrap;
}

.dt-action-cell {
  display: flex; align-items: center; justify-content: center;
  width: 36px; margin: 0 auto; padding: 0;
}
.dt-action-cell >>> .dropdown { position: static; }
.dt-action-cell >>> .dropdown-toggle,
.dt-action-cell >>> a.dropdown-toggle,
.dt-action-cell >>> .btn.dropdown-toggle {
  width: 36px; height: 36px; min-width: 36px; max-width: 36px; padding: 0 !important;
  border-radius: 10px; border: 1px solid var(--dt-border); background: #fff;
  color: #94a3b8; display: inline-flex; align-items: center; justify-content: center;
  box-shadow: none; line-height: 1; transition: all .18s ease;
}
.dt-action-cell >>> .dropdown-toggle::after { display: none; }
.dt-action-cell >>> .dropdown-toggle i { font-size: 20px; line-height: 1; }
.dt-action-cell >>> .dropdown-toggle:hover,
.dt-action-cell >>> .dropdown-toggle:focus,
.dt-action-cell >>> .dropdown.show > .dropdown-toggle {
  color: var(--dt-primary); border-color: #93c5fd; background: linear-gradient(180deg, #fff 0%, #eff6ff 100%);
  box-shadow: 0 4px 14px rgba(37, 99, 235, 0.14); transform: translateY(-1px);
}
.dt-action-cell >>> .dropdown-menu {
  min-width: 168px; padding: 6px; border: 1px solid var(--dt-border);
  border-radius: 12px; box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12);
}
.dt-action-cell >>> .dropdown-item {
  border-radius: 8px; padding: 9px 12px; font-size: 0.8125rem; font-weight: 500; color: #334155;
  transition: background .12s ease, color .12s ease;
}
.dt-action-cell >>> .dropdown-item:hover,
.dt-action-cell >>> .dropdown-item:focus {
  background: #eff6ff; color: var(--dt-primary);
}

</style>



<template>

  <div class="dt-root">

    <div class="dt-toolbar" v-if="tableData.searchable">

      <div class="d-flex align-items-start gap-3 flex-wrap">

        <div class="flex-grow-1" v-if="tableData.searchable.visible" style="min-width: 240px;">

          <div class="dt-search">

            <i class="fa fa-search dt-search__icon"></i>

            <input type="text" class="dt-search__input" :placeholder="tableData.searchable.placeholder" @input="search($event)">

          </div>

        </div>

        <div class="dt-actions">

          <slot name="toolbar"></slot>

          <button class="dt-btn dt-btn--excel" v-if="tableData.excel" @click="excelExport">

            <i class="fa fa-file-excel"></i> Excel'e Al

          </button>

          <button class="dt-btn dt-btn--filter" :class="{ 'is-active': detailMenuOpen }" v-if="tableData.detail" @click="detailMenuOpen = !detailMenuOpen">

            <i class="fa fa-filter"></i> Detaylı Ara

          </button>

        </div>

      </div>

      <div class="dt-filters row g-3" v-if="tableData.detail && detailMenuOpen">

        <slot name="searchItems"></slot>

      </div>

    </div>



    <div class="dt-meta" v-if="!loading">

      <div class="dt-meta__count">

        <span class="dt-badge">Kayıt</span>

        Toplam <strong>{{ tableData.pagination.total || 0 }}</strong>

      </div>

      <ul class="dt-pagination" v-if="tableDataLoad == 'pagination' && tableData.pagination.last_page > 1">

        <li v-if="tableData.pagination.current_page > 1">

          <a href="#" @click.prevent="changePage(tableData.pagination.current_page - 1)" class="dt-page-link">

            <i class="mdi mdi-chevron-left"></i> {{ tableData.pagination.current_page - 1 }}. Sayfa

          </a>

        </li>

        <li>

          <span class="dt-page-link is-current">{{ tableData.pagination.current_page }}. Sayfa</span>

        </li>

        <li v-if="tableData.pagination.current_page !== tableData.pagination.last_page">

          <a href="#" @click.prevent="changePage(tableData.pagination.current_page + 1)" class="dt-page-link">

            {{ tableData.pagination.current_page + 1 }}. Sayfa <i class="mdi mdi-chevron-right"></i>

          </a>

        </li>

      </ul>

      <div class="d-flex gap-3">

        <div v-if="$slots.filters"><slot name="filters"></slot></div>

        <div v-if="$slots.button"><slot name="button"></slot></div>

      </div>

    </div>



    <div class="dt-card">

      <div v-if="loading" class="dt-loading">

        <i class="fas fa-spinner fa-spin"></i> Veriler yükleniyor...

      </div>

      <div v-else-if="!tableData.data || !tableData.data.length" class="dt-empty">

        <div class="dt-empty__icon"><i class="bx bx-data"></i></div>

        <div>Kayıt bulunamadı</div>

      </div>

      <div v-else class="table-responsive dt-table-wrap">

        <table class="table dt-table">

          <thead>

            <tr>

              <th class="dt-index">#</th>

              <th

                v-for="(column, index) in columns"

                :key="index"

                :role="column.orderable ? 'button' : ''"

                :class="[

                  column.className || 'text-start',

                  column.orderable ? 'dt-sortable' : '',

                  sortedColumn === column.key && sortOrder ? 'dt-sort-active' : '',

                  column.key === 'action' ? 'dt-col-action' : ''

                ]"

                :style="getColumnStyle(column, true)"

                @click="sortColumn(column)"

              >

                <span class="d-inline-flex align-items-center gap-2">

                  {{ column.name }}

                  <i v-if="column.orderable" class="dt-sort-icon bx bxs-sort-alt"></i>

                </span>

              </th>

            </tr>

          </thead>

          <tbody>

            <tr

              v-for="(row, rowIndex) in tableData.data"

              :key="rowIndex"

              class="dt-row"

              tabindex="0"

              @click="$emit('row-click', row)"

              @keydown.enter="$emit('row-click', row)"

            >

              <th class="dt-index">

                {{ tableDataLoad == 'pagination' ? ((tableData.pagination.current_page - 1) * 50 || 0) + rowIndex + 1 : rowIndex + 1 }}

              </th>

              <td

                v-for="(column, colIndex) in columns"

                :key="colIndex"

                class="align-middle"

                :class="[

                  column.className || 'text-start',

                  column.key === 'action' ? 'dt-col-action' : '_cell'

                ]"

                :style="getColumnStyle(column, false)"
                :title="cellTitle(row, column)"

              >

                <div v-if="column.key === 'action'" class="dt-action-cell" @click.stop>

                  <slot :name="column.key" :row="row">{{ row[column.key] }}</slot>

                </div>

                <slot v-else :name="column.key" :row="row">{{ row[column.key] }}</slot>

              </td>

            </tr>

          </tbody>

        </table>

      </div>

    </div>



    <div v-if="poading" class="dt-loading-more">

      <i class="fas fa-spinner fa-spin"></i> Daha fazla kayıt yükleniyor...

    </div>

  </div>

</template>



<script>

export default {

  name: 'Datatable',

  props: {

    columns: Array,

    tableData: Object,

    sort: Object,

    loading: {

      type: Boolean,

      default: false

    },

    poading: {

      type: Boolean,

      default: false

    },

    tableDataLoad: {

      type: String,

      default: 'scroll'

    }

  },

  data() {

    return {

      sortOrder: null,

      sortedColumn: null,

      detailMenuOpen: (this.tableData && this.tableData.detailOpen) ? true : false

    };

  },

  methods: {
    cellTitle(row, column) {
      if (!column || column.key === 'action' || column.key === 'appointment' || column.key === 'appointment_at') return null;
      const value = row[column.key];
      if (value == null || typeof value === 'object') return null;
      const text = String(value).trim();
      return text || null;
    },

    getColumnStyle(column, isHeader) {
      if (column && column.key === 'action') {
        return 'width:52px; min-width:52px; max-width:52px;';
      }
      if (!column || !column.width) return '';
      if (isHeader) {
        return 'width:' + column.width + 'px; max-width:' + column.width + 'px;';
      }
      return 'max-width:' + column.width + 'px;';
    },

    search({ target }) {
      this.$emit('search-query', target.value);
    },

    sortColumn(column) {
      if (column.orderable) {
        if (this.sortedColumn === column.key) {
          this.sortOrder = this.sortOrder === 'asc' ? 'desc' : (this.sortOrder === 'desc' ? null : 'asc');
        } else {
          this.sortedColumn = column.key;
          this.sortOrder = 'asc';
        }
        this.$emit('sort-column', this.sortedColumn, this.sortOrder);
      }
    },

    getSortIcon(columnKey) {
      if (this.sort && this.sort.column && this.sort.column == columnKey) {
        this.sortedColumn = columnKey;
        this.sortOrder = this.sort.order;

        if (this.sort.order == 'desc') return 'fas fa-sort-up';
        if (this.sort.order == 'asc') return 'fas fa-sort-down';
      }

      if (this.sortedColumn === columnKey && this.sortOrder) {
        return this.sortOrder === 'asc' ? 'fas fa-sort-down' : 'fas fa-sort-up';
      }
      return 'fa fa-sort';
    },



    sortByColumn(a, b) {

      if (!this.sortedColumn) return 0;



      const column = this.sortedColumn;

      const order = this.sortOrder === 'desc' ? -1 : 1;



      if (a[column] < b[column]) return -1 * order;

      if (a[column] > b[column]) return 1 * order;

      return 0;

    },



    excelExport() {

      this.$emit('excel-export');

    },



    changePage(page) {

      if (page >= 1 && page <= this.tableData.pagination.last_page) {

        this.$emit('page-change', page);

      }

    },



    goToPage(value) {

      const page = parseInt(value);

      if (!isNaN(page)) {

        this.changePage(page);

      }

    },



    changePerPage(event) {

      const perPage = parseInt(event.target.value);

      if (!isNaN(perPage)) {

        this.$emit('per-page-change', perPage);

      }

    }

  }

};

</script>

